<template>
  <v-container class="pb-8 mb-16">
    <!-- main layout -->
    <v-row class="text-white">
      <!-- domestic violence card title -->
      <v-col cols="12">
        <h1 role="heading" aria-level="1" class="text-h1 mt-8 mb-4">
          {{ $t('L_new_york_domestic_violence_notice') }}
        </h1>
      </v-col>
      <!-- main content flex -->
      <v-col cols="12" id="main-flex" class="pb-8 mb-16">
        <v-card>
          <v-card-title>
            <h2 class="text-h2">{{ $t('L_confidentiality_information') }}</h2>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <h5 class="text-h5 font-weight-medium mb-2">
              {{ $t('L_know_your_rights') }}
            </h5>
            <p class="mb-2">
              <a href="javascript:void(0)" @click="openDocument('insurance')">
                <h4 class="text-h4 font-weight-medium">{{ $t('L_ny_ins_law') }}</h4>
              </a>
            </p>
            <p class="mb-2">
              <a href="javascript:void(0)" @click="openDocument('confidential')">
                <h4 class="text-h4 font-weight-medium">
                  {{ $t('L_confidential_comm_req') }}
                </h4>
              </a>
            </p>
          </v-card-text>
          <ViewContactDetails />
        </v-card>
      </v-col>
      <EmbeddedViewer
        :title="document.title"
        :loading="document.loading"
        content-type="application/pdf"
        :content-url="document.content"
        @close="document.content = undefined"
      />
    </v-row>
  </v-container>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import EmbeddedViewer from '@/components/EmbeddedViewer.vue';
import ViewContactDetails from './components/ViewContactDetails.vue';
import { mapState } from 'pinia';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';

const componentOptions: ComponentOptions = {
  name: 'DomesticViolence',
  components: {
    EmbeddedViewer,
    ViewContactDetails,
  },
  data: () => ({
    showModal: false,
    document: {
      title: '',
      content: '' as string | undefined,
      loading: false,
    },
    url: `${window.appConfig.content_stack}${window.appConfig.policyDocumentForms.en_NY.nyInsuranceLaw}`,
    confidentialCommunication: {
      url: `${window.appConfig.content_stack}${window.appConfig.policyDocumentForms.en_NY.confidentialCommunication}`,
      name: 'L_confidential_communication_card',
    },
  }),
  computed: {
    ...mapState(useGlobalStore, ['getAgent']),
    ...mapState(usePolicyStore, {
      policyData: 'currentPolicy',
    }),
    isRestricted() {
      return this.policyData?.restricted;
    },
    agents() {
      return [this.getAgent(this?.policyData?.agentId)];
    },
  },
  methods: {
    openDocument(type: string) {
      if (type === 'confidential') {
        this.document.content = this.confidentialCommunication.url;
        this.document.title = this.$t(this.confidentialCommunication.name);
      } else if (type === 'insurance') {
        this.document.content = this.url;
        this.document.title = this.$t('L_insurance_law_title');
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>
